import { Node_Type } from 'ricos-schema';

var LinkPreviewProviders = /* @__PURE__ */ ((LinkPreviewProviders2) => {
  LinkPreviewProviders2["Instagram"] = "Instagram";
  LinkPreviewProviders2["Twitter"] = "Twitter";
  LinkPreviewProviders2["YouTube"] = "YouTube";
  LinkPreviewProviders2["TikTok"] = "TikTok";
  return LinkPreviewProviders2;
})(LinkPreviewProviders || {});
const socialModals = {
  instagram: `${Node_Type.LINK_PREVIEW}.instagram`,
  facebook: `${Node_Type.LINK_PREVIEW}.facebook`,
  tiktok: `${Node_Type.LINK_PREVIEW}.tiktok`,
  twitter: `${Node_Type.LINK_PREVIEW}.twitter`,
  pinterest: `${Node_Type.LINK_PREVIEW}.pinterest`
};
const linkPreviewModals = {
  settings: `${Node_Type.LINK_PREVIEW}.settings`
};

export { LinkPreviewProviders, linkPreviewModals, socialModals };
//# sourceMappingURL=consts.js.map
